// Stripe's billing portal: where a paying parent changes plan, updates their card, sees invoices or cancels.
// The server finds the account's Stripe customer and returns a one-time portal address (server.js /api/billing-portal).
import { authHeaders } from './apiAuth';
import { SPARKY_SERVER_URL } from '../components/shared/constants';

/** Sends the browser to the portal. Resolves with an error message for the parent if it could not open. */
export async function openBillingPortal() {
  try {
    const res = await fetch(`${SPARKY_SERVER_URL}/api/billing-portal`, { method: 'POST', headers: { 'Content-Type': 'application/json', ...(await authHeaders()) } });
    const data = await res.json().catch(() => ({}));
    if (data.url) { window.location.href = data.url; return null; }
    if (res.status === 401) return 'Please sign in again, then try once more.';
    if (data.error === 'no-subscription') return 'This account has no paid plan to manage yet.';
    return 'Billing could not open just now. Please try again in a minute, or email hello@empirio.com.au.';
  } catch (_) {
    return 'Billing could not open. Check your internet connection and try again.';
  }
}
